import { CloseCircleOutlined, ExportOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Layout, Radio, Row, Space, Table, Tag, Tooltip } from "antd";
import Search from "antd/es/input/Search";
import { Content, Footer } from "antd/es/layout/layout";
import { useForm } from "antd/lib/form/Form";
import { AutoCompleteCompany, CardInfo, FormatDate, FormatMoney, Header, LoadingText } from "components";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { formatDate, formatMoney } from "utils";
import { getCompanyEmployeesByFilter, getCompanySolicitations, getTotalBalance } from "services/company-service";
import { getUserStatementByFilter } from "services/user-service";
import { getAllBenefit } from "services/benefit-service";
import { utils, writeFile } from "xlsx";
import { useNavigate } from "react-router-dom";
import { isOperatorType } from "utils/static-data";

const { RangePicker } = DatePicker;
const BUSINESS = "business";
const PERSON = "person";
const DEFAULT_SORTER = "date:desc";
const CANCEL_STATUS = "Cancelado";

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer,
    balance: state.balanceReducer,
});

const STATUS = [
    { text: 'Aguardando Pré-Cadastro', value: 'Aguardando Cadastro' },
    { text: 'Aprovado', value: 'Aprovado' },
    { text: 'Cancelado', value: 'Cancelado' },
    { text: 'Carregando', value: 'Carregando' },
    { text: '-', value: 'Expirado' },
    { text: 'Falha', value: 'Falha' },
    { text: 'Finalizado', value: 'Finalizado' },
    { text: 'Pago', value: 'Pago' },
    { text: 'Pendente', value: 'Pendente' },
    { text: 'Recusado', value: 'Recusado' }
];

const ExtractScreen = (props) => {
    const { login } = props;
    const [form] = useForm();
    const [loading, setLoading] = useState(false);
    const [option, setOption] = useState(BUSINESS);
    const [company, setCompany] = useState(null);
    const [companyBalance, setCompanyBalance] = useState(0);
    const [amountCompany, setAmountCompany] = useState(0);
    const [amountUsers, setAmountUsers] = useState(0);
    const [companyExtract, setCompanyExtract] = useState([]);
    const [usersExtract, setUsersExtract] = useState([]);
    const [benefits, setBenefits] = useState({});
    const [benefitFilters, setBenefitFilters] = useState([]);
    const [exportBusinessData, setExportBusinessData] = useState([]);
    const [exportPersonData, setExportPersonData] = useState([]);
    const [pageCompany, setPageCompany] = useState(1);
    const [pageSizeCompany, setPageSizeCompany] = useState(10);
    const [pageUsers, setPageUsers] = useState(1);
    const [pageSizeUsers, setPageSizeUsers] = useState(10);
    const [totalCompany, setTotalCompany] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [filterCompany, setFilterCompany] = useState(null);
    const [filterUsers, setFilterUsers] = useState(null);
    const [dateString, setDateString] = useState(null);
    const [inputSearch, setInputSearch] = useState(null);
    const [companySorter, setCompanySorter] = useState(DEFAULT_SORTER);
    const [usersSorter, setUsersSorter] = useState(DEFAULT_SORTER);
    const [companyFilterTypes, setCompanyFilterTypes] = useState(null);
    const [usersFilterTypes, setUsersFilterTypes] = useState(null);
    const [companyFilterBenefits, setCompanyFilterBenefits] = useState(null);
    const [companyFilterStatus, setCompanyFilterStatus] = useState(null);
    const [usersFilterBenefits, setUsersFilterBenefits] = useState(null);
    const [usersFilterStatus, setUsersFilterStatus] = useState(null);
    const [userTableFilters, setUserTableFilters] = useState({});
    const [companyTableFilters, setCompanyTableFilters] = useState({});
    const cardRef = useRef(null);
    const [cardHeight, setCardHeight] = useState(null);
    const [cardWidth, setCardWidth] = useState(null);
    const navigate = useNavigate();

    const getStatusText = (statusName) => {
        const found = STATUS.find(s => s.value.toUpperCase() === statusName?.toUpperCase());
        return found ? found.text.toUpperCase() : (statusName?.toUpperCase() || '-');
    };


    const personColumns = [
        {
            title: 'PARTICIPANTE',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
            width: 200,
            render: (name) => name || '-'
        },
        {
            title: 'CPF',
            dataIndex: 'cpf',
            key: 'cpf',
            align: 'center',
            width: 200,
            render: (cpf) => cpf || '-'
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: 200,
            render: id => (
                          <Button size="small" type={"link"} onClick={() => navigate(`/user/${id}/statement`)}>
                            Ver extrato
                          </Button>
                        )
        }
    ];

    const businessColumns = [
        {
            title: 'DATA | HORA',
            dataIndex: 'date',
            key: 'date',
            align: 'center',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (rowA, rowB) => rowA.date - rowB.date,
            render: (date) => <FormatDate value={date} format="DD/MM/YYYY HH:mm:ss" />
        },
        {
            title: 'PARTICIPANTE',
            dataIndex: 'employee',
            key: 'employee',
            align: 'center',
            width: 200,
            render: (employee) => employee || '-',
        },
        {
            title: 'CPF/CNPJ',
            dataIndex: 'document',
            key: 'document',
            align: 'center',
            width: 200,
            render: (document) => document || '-'
        },
        {
            title: 'VALOR',
            dataIndex: 'value',
            key: 'value',
            align: 'center',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (dataA, dataB) => dataA.value - dataB.value,
            render: (value) => <FormatMoney value={value} />
        },
        {
            title: 'TIPO',
            dataIndex: 'type',
            key: 'type',
            align: 'center',
            width: 200,
            filteredValue: companyTableFilters.type || null,
            filters: [
                { text: 'Carga', value: 'Carga' },
                { text: 'Crédito', value: 'Crédito' },
                { text: 'Resgate', value: 'Resgate' },
            ],
            render: (value) => {
                return <Tag color={value.category}>{value.name.toUpperCase()}</Tag>;
            }
        },
        // {
        //     title: 'SALDO APÓS TRANSF.',
        //     dataIndex: 'valueTransfer',
        //     key: 'valueTransfer',
        //     align: 'center',
        //     width: 200,
        //     render: (value) => <FormatMoney value={value} />
        // },
        {
            title: 'STATUS',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 250,
            filteredValue: companyTableFilters.status || null,
            filters: STATUS,
            render: (value) => {
                if (value === "loading") {
                    return <LoadingText loading={true} />;
                }
                const statusText = getStatusText(value.name);
                return statusText === '-' ? statusText : <Tag color={value.category}>{statusText}</Tag>;
            }
        },
        {
            title: 'SEGMENTAÇÃO',
            dataIndex: 'benefit',
            key: 'benefit',
            align: 'center',
            width: 200,
            filteredValue: companyTableFilters.benefit || null,
            filters: benefitFilters,
            render: (benefit) => <Tag color={'default'}>{benefit?.name || '-'}</Tag>
        }
    ];

    const onSort = (sorter) => {
        if ('field' in sorter && 'order' in sorter) {
            const column = sorter.field;
            const order = sorter.order === 'ascend' ? 'asc' : 'desc';
            if (option === BUSINESS) {
                setCompanySorter(`${column}:${order}`);
            } else {
                setUsersSorter(`${column}:${order}`)
            }
        }
    }

    const onSelectFilter = (filter) => {
        if (!filter || (!filter?.status && !filter?.benefit && !filter?.type)) {
            if (option === BUSINESS) {
                setCompanyTableFilters({});
                setCompanyFilterTypes(null);
                setCompanyFilterBenefits(null);
                setCompanyFilterStatus(null);
            } else {
                setUserTableFilters({});
                setUsersFilterTypes(null);
                setUsersFilterBenefits(null);
                setUsersFilterStatus(null);
            }
            return;
        }

        const { benefit, status, type } = filter;
        if (option === BUSINESS) {
            setCompanyTableFilters(filter);
            setCompanyFilterTypes(type?.join(':') || null);
            setCompanyFilterBenefits(benefit?.join(':') || null);
            setCompanyFilterStatus(status?.join(':') || null);
        } else {
            setUserTableFilters(filter);
            setUsersFilterTypes(type?.join(':') || null);
            setUsersFilterBenefits(benefit?.join(':') || null);
            setUsersFilterStatus(status?.join(':') || null);
        }
    }

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        if (company) {
            load();
        }
    }, [company])

    useEffect(() => {
        if (company) {
            onFilter();
        }
    }, [
        pageUsers,
        pageSizeUsers,
        pageCompany,
        pageSizeCompany,
        dateString,
        filterCompany,
        filterUsers,
        companySorter,
        usersSorter,
        companyFilterTypes,
        usersFilterTypes,
        usersFilterBenefits,
        usersFilterStatus,
        companyFilterBenefits,
        companyFilterStatus,
    ])

    useEffect(() => {
        const updateDimensions = () => {
            if (cardRef.current) {
                setCardHeight(cardRef.current.offsetHeight);
                setCardWidth(cardRef.current.offsetWidth);
            }
        };

        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, [companyBalance, loading]);

    const init = () => {
        setLoading(true);
        if (!login.company.master) {
            setCompany(login.company.id);
        }
        if(isOperator() && !login.company.master) {
            setOption(PERSON);
        }
        setLoading(false);
    }

    const isOperator = () => {
        return isOperatorType(login.user.userType);
    }

    const isMasterOperator = () => {
        return isOperatorType(login.user.userType) && login.company.master;
    }

    const load = async () => {
        setLoading(true);
        try {
            if (!company || company === undefined || (isOperator() && !login.company.master)) {
                return;
            }

            const { data, total, amount } = await getCompanySolicitations({
                companyID: company,
                page: pageCompany,
                pageSize: pageSizeCompany,
                sorter: companySorter,
                types: companyFilterTypes,
                benefits: companyFilterBenefits,
                status: companyFilterStatus,
            });

            setCompanyExtract(data);
            const response = await getTotalBalance(company);
            setCompanyBalance(response.balance);
            setAmountCompany(amount);
            setExportBusinessData(data);
            setTotalCompany(total);
            await loadBenefits();

        } finally {
            setLoading(false);
        }
    }

    const onFilter = async () => {
        if (!company) {
            return;
        }
        setLoading(true);
        try {
            if (option === BUSINESS) {
                const { data: solicitations, total, amount } = await getCompanySolicitations({
                    companyID: company,
                    page: pageCompany,
                    pageSize: pageSizeCompany,
                    filter: filterCompany,
                    dates: dateString,
                    sorter: companySorter,
                    types: companyFilterTypes,
                    benefits: companyFilterBenefits,
                    status: companyFilterStatus,
                });
                setCompanyExtract(solicitations);
                setExportBusinessData(solicitations);
                setTotalCompany(total);
                setAmountCompany(amount);
            } else {
                if (!filterUsers || filterUsers.trim().length === 0) {
                    setUsersExtract([]);
                    setExportPersonData([]);
                    setTotalUsers(0)
                    return;
                }
                const data = await getCompanyEmployeesByFilter({
                    companyID: company,
                    filter: filterUsers,
                    page: pageUsers,
                    pageSize: pageSizeUsers,
                });
                if(data.success)
                setUsersExtract(data.users);
            }
        } finally {
            setLoading(false);
        }
    }


    const onExport = async () => {
        try {
            const emptyBusinessData = option === BUSINESS && exportBusinessData.length === 0;
            const emptyPersonData = option === PERSON && ExportOutlined.length === 0;
            if (emptyBusinessData || emptyPersonData) {
                return;
            }

            setLoading(true);
            const currentData = option === BUSINESS ?
                await getCompanySolicitations({
                    companyID: company,
                    page: pageCompany,
                    pageSize: pageSizeCompany,
                    filter: filterCompany,
                    dates: dateString,
                    listAll: true,
                    sorter: companySorter,
                    types: companyFilterTypes,
                    benefits: companyFilterBenefits,
                    status: companyFilterStatus,
                }) :
                await getUserStatementByFilter({
                    companyID: company,
                    filter: filterUsers,
                    page: pageUsers,
                    pageSize: pageSizeUsers,
                    dates: dateString,
                    listAll: true,
                    sorter: usersSorter,
                    types: usersFilterTypes,
                    benefits: usersFilterBenefits,
                    status: usersFilterStatus,
                });

            const formatedData = (option === BUSINESS ? currentData.data : currentData.data).map(row => {
                if (option === BUSINESS) {
                    return {
                        'DATA | HORA': formatDate(row.date, "DD/MM/YYYY HH:mm:ss"),
                        'PARTICIPANTE': row?.employee || '-',
                        'CPF/CNPJ': row?.document || '-',
                        'VALOR': formatMoney(row.value || 0),
                        'TIPO': row?.type?.name || '-',
                        // 'SALDO APÓS TRANSF.': formatMoney(row?.amountBeforeTransfer || 0),
                        'STATUS': getStatusText(row?.status?.name) || '-',
                        'SEGMENTAÇÃO': row?.benefit?.name || '-',
                    }
                }

                return {
                    'DATA | HORA': formatDate(row.date, "DD/MM/YYYY HH:mm:ss"),
                    'PARTICIPANTE': row.employee || '-',
                    'VALOR': formatMoney(row.value || 0, true),
                    'TIPO': row?.type || '-',
                    // 'CIDADE | UF': row.city || '-',
                    'STATUS': row?.status?.name || '-',
                    'MCC': row?.mcc || '-',
                    'SEGMENTAÇÃO': row?.benefit?.name || '-',
                }

            });

            const workSheet = utils.json_to_sheet(formatedData);
            const workBook = utils.book_new();
            utils.book_append_sheet(workBook, workSheet, 'Extrato');
            const fileName = `relatorio_${new Date().toISOString()}.xlsx`;
            writeFile(workBook, fileName);
            setLoading(false);
        } finally {
            setLoading(false);
        }

    }

    const loadBenefits = async () => {
        if (company) {
            const benefits = await getAllBenefit();
            setBenefits(benefits);
            const benefitFilters = benefits.map((benefit) => ({ text: benefit.name, value: benefit.name }));
            setBenefitFilters(benefitFilters);
        }
    }

    const resetPagination = () => {
        if (option === BUSINESS) {
            setPageCompany(1);
            setPageSizeCompany(10);
        } else {
            setPageUsers(1);
            setPageSizeUsers(10);
        }
    }


    const handleDateChange = (dates) => {
        if (dates[0].length > 0 && dates[1].length > 0) {
            const [startDate, endDate] = dates.map(date => {
                const [day, month, year] = date.split('/');
                return `${year}-${month}-${day}`;
            });

            const formatedDateString = `${startDate}:${endDate}`;
            setDateString(formatedDateString);
        } else {
            setDateString(null);
        }
    }


    return (
        <Layout className="alymente-layout">
            <Header
                title="Extrato Geral"
                middle={
                    login.company.master ? <AutoCompleteCompany value={company} onChange={setCompany} /> : null
                }
            />
            <Content>
                {
                    company && <>
                        {!isOperator() && <>
                            <Row gutter={24} align="middle">
                                <Col xl={6} ref={cardRef}>
                                    <CardInfo
                                        info="Saldo disponível para a empresa."
                                        loading={loading}
                                        title="Saldo Atual"
                                        value={formatMoney(companyBalance || 0)}
                                    />
                                </Col>
                                <Col xl={6}>
                                    {
                                        ((option === BUSINESS && Object.values(companyTableFilters).length > 0 && !companyTableFilters?.status?.includes(CANCEL_STATUS)) || (option === PERSON && Object.values(userTableFilters).length > 0)) && <CardInfo
                                            info="Montante referente aos valores filtrados."
                                            loading={loading}
                                            title="Valor Selecionado"
                                            value={formatMoney((option === BUSINESS ? amountCompany : amountUsers) || 0)}
                                        />
                                    }
                                </Col>
                                <Col xl={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {(option === BUSINESS) &&
                                        <div
                                            style={{
                                                background: '#f5f5f5',
                                                borderRadius: 8,
                                                padding: '16px 20px',
                                                fontSize: 14,
                                                color: '#595959',
                                                lineHeight: 1.5,
                                                textAlign: 'center',
                                                width: cardWidth ? `${cardWidth}px` : '100%',
                                                height: cardHeight ? `${cardHeight}px` : 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <span>
                                                Extrato referente aos últimos 3 meses.{' '}
                                                <strong>Para consultar outro período</strong>, selecione abaixo a data inicial e a data final.
                                            </span>
                                        </div>
                                    }
                                </Col>
                            </Row>

                            <Row style={{ marginTop: 20, padding: 0 }} justify="center" align="middle" >
                                <Radio.Group
                                    disabled={loading}
                                    options={[
                                        { label: 'Extrato Empresa', value: BUSINESS },
                                        { label: 'Extrato Participante', value: PERSON },
                                    ]}
                                    onChange={(event) => {
                                        setOption(event.target.value);
                                    }}
                                    value={option}
                                    optionType="button"
                                    buttonStyle="solid"
                                />
                            </Row>
                        </>}

                        <Table
                            rowKey={"id"}
                            expandable={true}
                            columns={option === BUSINESS ? businessColumns : personColumns}
                            scroll={{ y: '50vh', x: 1000 }}
                            dataSource={option === BUSINESS ? companyExtract : usersExtract}
                            loading={loading}
                            pagination={false}
                            bordered
                            sortDirections={['ascend', 'descend']}
                            showSorterTooltip={true}
                            onChange={(pagination, filters, sorter, extra) => {
                                onSort(sorter);
                                onSelectFilter(filters);
                            }}
                            pagination={{
                                current: option === BUSINESS ? pageCompany : pageUsers,
                                total: option === BUSINESS ? totalCompany : totalUsers,
                                pageSize: option === BUSINESS ? pageSizeCompany : pageSizeUsers,
                                showTotal: (total, range) => `${range[1]} de ${total}`,
                                disabled: loading,
                                showSizeChanger: true,
                                onChange: (page, pageSize) => {
                                    if (option === BUSINESS) {
                                        if (pageSize !== pageSizeCompany) {
                                            setPageCompany(1);
                                            setPageSizeCompany(pageSize);
                                        } else {
                                            setPageCompany(page);
                                            setPageSizeCompany(pageSize);
                                        }
                                    } else {
                                        if (pageSize !== pageSizeUsers) {
                                            setPageUsers(1);
                                            setPageSizeUsers(pageSize);
                                        } else {
                                            setPageUsers(page);
                                            setPageSizeUsers(pageSize);
                                        }
                                    }
                                }
                            }}
                            title={() => (
                                <Row style={{ margin: 0, padding: 0 }} align="bottom" justify="space-between">
                                    <Col span={6} style={{ textAlign: 'start' }}>
                                        <Form
                                            style={{ padding: 0, margin: 0 }}
                                            name="basic"
                                            form={form}
                                            onFinish={(values) => {
                                                if (option === BUSINESS) {
                                                    setFilterCompany(values.filterValue);
                                                } else {
                                                    setFilterUsers(values.filterValue);
                                                }
                                                resetPagination();
                                            }}
                                        >
                                            <Form.Item
                                                name="filterValue"
                                                style={{ padding: 0, margin: 0 }}
                                            >
                                                <Search
                                                    value={option === BUSINESS ? filterCompany : filterUsers}
                                                    onSearch={value => {
                                                        if (option === BUSINESS) {
                                                            setFilterCompany(value);
                                                        } else {
                                                            setFilterUsers(value);
                                                        }
                                                        resetPagination();
                                                    }}
                                                    placeholder="Nome, CPF ou E-mail"
                                                    allowClear={false}
                                                    disabled={loading}
                                                    onChange={(event) => {
                                                        const value = event.target.value;
                                                        setInputSearch(value);
                                                    }}
                                                    suffix={
                                                        !loading && (<Tooltip title="Limpar Pesquisa">
                                                            <CloseCircleOutlined
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    form.resetFields();
                                                                    if (option === BUSINESS) {
                                                                        setFilterCompany(null);
                                                                    } else {
                                                                        setFilterUsers(null);
                                                                        setAmountUsers(0);
                                                                    }
                                                                    setDateString(null);
                                                                    resetPagination();
                                                                    onSelectFilter(null);
                                                                }}
                                                            />
                                                        </Tooltip>)
                                                    }
                                                />
                                            </Form.Item>
                                        </Form>
                                    </Col>

                                    <Col span={6} style={{ textAlign: 'end' }}>
                                        {option === BUSINESS &&
                                            <RangePicker
                                                format="DD/MM/YYYY"
                                                inputReadOnly={false}
                                                allowClear={true}
                                                disabled={loading || (option === PERSON && (!filterUsers || filterUsers.trim().length === 0) && exportBusinessData.length > 0) || (option === PERSON && (inputSearch || '').trim().length === 0)}
                                                showNow={true}
                                                onChange={(_, dates) => {
                                                    if (option === BUSINESS) {
                                                        setFilterCompany(inputSearch);
                                                    } else {
                                                        setFilterUsers(inputSearch);
                                                    }
                                                    handleDateChange(dates);
                                                }}
                                                clearIcon={
                                                    !loading && (<Tooltip title="Limpar Datas">
                                                        <CloseCircleOutlined style={{ cursor: 'pointer' }} />
                                                    </Tooltip>)
                                                }
                                                disabledDate={(current) => {
                                                    return current && current > moment().endOf('day');
                                                }}
                                            />
                                        }
                                    </Col>
                                </Row>
                            )}
                        />
                    </>
                }
            </Content>
            <Footer>
                <Space align="end">
                    {option === BUSINESS &&
                        <Button
                            disabled={loading || (option === BUSINESS && exportBusinessData?.length === 0)}
                            loading={loading}
                            className="btn-save"
                            type="primary"
                            icon={<ExportOutlined />}
                            onClick={() => onExport()}
                        >
                            Exportar Relatório
                        </Button>
                    }
                </Space>
            </Footer>
        </Layout >
    )
}

export default connect(mapStateToProps, {})(ExtractScreen);
